import {svodApi} from "@/api/svodApi";
import {useCookies} from "vue3-cookies";
import app from "@/main";

export function usePromo() {
    const add = async (promo) => {
        const {data} = await svodApi.get('/qr?id=' + promo);
        list();
        return data;
    }
    const addByField = async (promo) => {
        const {data} = await svodApi.get('/xpromo?id=' + promo);
        list();
        return data;
    }
    const list = async (route = null) => {
        const {cookies} = useCookies();

        const {data} = await svodApi.post('/userpromo', {
            cmd: 'list',
            promo: '',
            section: route?.name ?? "",
            mrktsid: cookies.get('server_sid'),
            UserAgent: window.navigator.userAgent ?? '',
        })

        app.config.globalProperties.$promoCodes.value = data;

        return data;
    }

    const waitForPromoCodes = () => {
        return new Promise(resolve => {
            const start = Date.now();
            const timeout = 60000; // 1 минута = 60000 мс

            const check = () => {
                const promoCodes = app.config.globalProperties.$promoCodes.value;
                if (Array.isArray(promoCodes)) {
                    resolve(promoCodes);
                } else if (Date.now() - start > timeout) {
                    resolve([]); // Если прошло больше минуты, считаем массив пустым
                } else {
                    setTimeout(check, 50);
                }
            };
            check();
        });
    };

    const byRoute = async (route) => {
        if (!route) return null;
        const promoCodes = await waitForPromoCodes();
        const promoCode = promoCodes.find(item => item.section === route.name);
        if (promoCode) {
            return promoCode;
        }
        return null;
    };

    return {add, list, addByField, byRoute}
}